import { Outlet } from 'react-router'

import { ErrorPageHeader } from './ErrorPageHeader'
import { ErrorPageLayout } from './ErrorPageLayout'

export function Error() {
  return (
    <ErrorPageLayout header={<ErrorPageHeader />}>
      <Outlet />
    </ErrorPageLayout>
  )
}
